import {
	IBaseNotificationPayload,
	IEditResponse,
	IListNotificationsSet,
	INotificationPayload,
	INotificationsSet,
	Partial,
} from '@modules/notification-management/interfaces/notifications.interface';
import { ISlackChannelsResponse } from '@core/services/integrations/integrations.interface';
import { ApiFacadeService } from '@app/services/api-facade.service';
import { delay, retryWhen, scan, takeWhile } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PostEventType, PostMessageOrigin, PostMessageService } from '@app/services/postMessage.service';

@Injectable({
	providedIn: 'root',
})
export class NotificationsApiService {
	constructor(private apiFacade: ApiFacadeService, private postMessageService: PostMessageService) {}

	public getSlackChannels(): Observable<ISlackChannelsResponse> {
		const url = 'integrations/get_slack_channels';
		const delayBetweenRetryCallsInSeconds = 1;
		const retryCount = 3;

		return this.apiFacade.post<ISlackChannelsResponse>(url).pipe(
			retryWhen((errors) =>
				errors.pipe(
					scan((acc) => acc + 1, 0),
					takeWhile((acc) => acc < retryCount),
					delay(delayBetweenRetryCallsInSeconds * 1000),
				),
			),
		);
	}

	public createNotificationEntity(notificationSet: INotificationPayload): Observable<IListNotificationsSet> {
		const url = 'notification-service/create_entity';
		return this.apiFacade.post<IListNotificationsSet>(url, notificationSet);
	}

	public editNotificationEntity(notificationSet: Partial<INotificationPayload>): Observable<IEditResponse> {
		const url = 'notification-service/edit_entity';
		return this.apiFacade.post<IEditResponse>(url, notificationSet);
	}

	public fetchNotificationEntities(payload: {}): Observable<IListNotificationsSet[]> {
		const url = 'notification-service/get_entities_list';
		return this.apiFacade.post<IListNotificationsSet[]>(url, payload);
	}

	public getEntity(payload: IBaseNotificationPayload): Observable<INotificationsSet> {
		const url = 'notification-service/get_entity';
		return this.apiFacade.post<INotificationsSet>(url, payload);
	}

	public deleteNotificationEntity(payload: any): Observable<IEditResponse> {
		const url = 'notification-service/delete_entity';
		return this.apiFacade.post<IEditResponse>(url, payload);
	}

	public dispatchRefreshNotificationList(): void {
		this.postMessageService.dispatchMessage({
			initiator: PostMessageOrigin.Host,
			type: PostEventType.RefreshNotificationList,
		});
	}
}
